/**
 * Authorization Roles
 */
const authRoles = {
  admin: ['admin', 'admin-restricted'],
  provider: ['provider-admin', 'provider-restricted'],
  user: ['agency-admin', 'agency-restricted'],
  commonuser: ['agency-admin', 'admin', 'admin-restricted', 'agency-restricted'],
  adminProvider: ['provider-admin', 'admin', 'admin-restricted', 'provider-restricted'],
  allUser: ['provider-admin', 'admin', 'agency-admin', 'admin-restricted', 'agency-restricted', 'provider-restricted'],
  onlyGuest: [],
};


// const authRoles = {
//     admin: [],
//     provider: []
//     agency: []
// }

export default authRoles;
